import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

/**
 * Fetch sociétés that completed an external signup but do not yet have an abonnement.
 * Restricted to authenticated users with the Dev role on the backend.
 */
export const fetchPendingSocietes = async () => {
  const response = await axios.get(`${API_URL}/support/societes`, {
    params: { pending: true },
  });
  return response.data;
};

export const fetchAllSocietes = async () => {
  const response = await axios.get(`${API_URL}/support/societes`);
  return response.data;
};

export const createSupportSociete = async (payload) => {
  const response = await axios.post(`${API_URL}/support/societes`, payload);
  return response.data;
};

export const updateSupportSociete = async (id, payload) => {
  const response = await axios.put(`${API_URL}/support/societes/${id}`, payload);
  return response.data;
};

export const deleteSupportSociete = async (id) => {
  const response = await axios.delete(`${API_URL}/support/societes/${id}`);
  return response.data;
};

export const createSupportSocieteAdmin = async (id, payload) => {
  const response = await axios.post(`${API_URL}/support/societes/${id}/admin`, payload);
  return response.data;
};

export const createSupportSocieteAbonnement = async (id, payload) => {
  const response = await axios.post(`${API_URL}/support/societes/${id}/abonnement`, payload);
  return response.data;
};

export const updateSupportSocieteAbonnement = async (societeId, abonnementId, payload) => {
  const response = await axios.put(
    `${API_URL}/support/societes/${societeId}/abonnement/${abonnementId}`,
    payload
  );
  return response.data;
};

export const fetchSupportAbonnementPlans = async () => {
  const response = await axios.get(`${API_URL}/support/abonnements/plans`);
  return response.data;
};
